<template>
  <v-container fluid>
    <v-layout row wrap >
      <v-flex xs1 md1 >
        <v-btn color="primary" dark text @click="createData(0)" >新增匯款</v-btn>
      </v-flex>
      <v-flex xs2 md2  pl-3 >
        <v-btn color="primary" dark text @click="createData(1)" >新增存入</v-btn>
      </v-flex>

      <v-flex xs3 md3 >
        <v-btn color="primary" dark text @click="showBankDialog(0)" >嘉好銀行相關管理</v-btn>
      </v-flex>
      <v-flex xs3 md3 >
        <v-btn color="primary" dark text @click="showBankDialog(1)" >常用帳戶管理</v-btn>
      </v-flex>
    </v-layout>

    <v-layout  mt-2>
      <v-flex xs5 sm5 md5>
        <date-picker :date.sync="search.startDate" />
      </v-flex>
      <v-flex xs5 sm5 md5>
        <date-picker :date.sync="search.endDate" />
      </v-flex>
    </v-layout>

    <v-layout mt-2>
      <v-flex xs2 md2 pr-3>
        <v-select
          :items="caseTypeList"
          item-text="text"
          item-value="key"
          v-model="typeStatus"
          @change="changeTypeStatus()"
        ></v-select>
      </v-flex>
        <v-flex md2 xs8 >
          <v-select :items="searchKeys"
                        item-text="value"
                        item-value="key"
                        v-model="search.searchKey"
                        label="查詢條件"
          ></v-select>
        </v-flex>
        <v-flex ml-2 md5 xs8>
          <v-text-field v-model="search.keyword" :label="`搜尋客戶`" :placeholder="search.placeholder"
          @keyup.enter="searchEvent"></v-text-field>
        </v-flex>
        <v-flex md4 xs4>
          <v-btn color="success" @click="searchEvent">搜尋</v-btn>
          <v-btn color="warning" @click="reset">重置</v-btn>
        </v-flex>
      </v-layout>
    <v-layout row wrap >
      <table-view :columnKeys="columnKeys"
                :items="items"
                :loading="loading"
                :total-items="totalItems"
                @cellEvent="cellEvent"
                @handleLoadData="reset">
      </table-view>
    </v-layout>
    <!--彈出視窗-->
    <alert-view :visible="messageDialog.visible"
                :title="messageDialog.title"
                :content="messageDialog.text"
                :isHtmlContent="true"
                :showCancel="messageDialog.showCancelButton"
                @cancelEvent="messageDialog.cancel"
                @confirmEvent="messageDialog.confirm"></alert-view>
    <CashFlowDialog :visible="cashInfoDialog.visible"
            :type="cashInfoDialog.type"
            :caseTypeList="caseTypeList"
            :bankItemList="bankItemList"
            :favoriteBankItemList="favoriteBankItemList"
            :item="editedItem"
            :isNew="isCreateInfo"
            @confirmEvent="cashInfoDialog.confirm"
            @closeEvent="cashInfoDialog.cancel"
    ></CashFlowDialog>
    <bank-manager-dialog :visible="bankDialog.visible"
            :favorite="bankDialog.favorite"
            @confirmEvent="bankDialog.confirm"
            @closeEvent="bankDialog.cancel">
    </bank-manager-dialog>

  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import MobileDetect from "mobile-detect";
import ListEditor from "../../components/ListEditor"
import AlertView from '@/components/AlertView';
import CashFlowDialog from '@/components/CashFlowDialog';
import BankManagerDialog from '@/components/BankManagerDialog';
import TableView from '@/components/TableView';
import CashFlowModel from '../../models/CashFlowModel';
import { getCurrentDate } from '@/pages/utils/tool';
import DatePicker from "@/components/DatePicker";

const bankCodeList = require('../../assets/bank_data.json');

const md = new MobileDetect(window.navigator.userAgent);
export default {
  name: "CashFlowView",
  components: {
    ListEditor,
    AlertView,
    CashFlowDialog,
    BankManagerDialog,
    TableView,
    DatePicker
  },
  data() {
    return {
      loading: false,
      isMobile: md.phone(),
      isCreateInfo: false,
      pageIndex: 1,
      limit: 5,
      totalItems: 0,
      search: {
        keyword: "",
        placeholder: "搜尋名稱",
        startDate:  getCurrentDate(),
        endDate:  getCurrentDate(),
        searchKey:'',
      },
      cashInfoDialog: {
        visible: false,
        confirm: () => {},
        cancel: () => {}
      },
      items: [],
      typeStatus:0,
      bankDialog: {
        title: "",
        text: "",
        visible: false,
        favorite: 0,
        confirm: () => {},
        cancel: () => {},
      },
      messageDialog: {
        title: "",
        text: "",
        visible: false,
        showCancelButton: false,
        confirm: () => {},
        cancel: () => {},
      },
      bankItemList: [],
      favoriteBankItemList:[],
      editedItem: new CashFlowModel() 
    };
  },
  created() {
    this.loadBankList()
    this.loadFavoriteBankList()
    // this.setDefualtDate();
    this.loadData(this.pageIndex, this.limit);
  },
  computed: {
    ...mapGetters(["getUserInfo", "getAgentList"]),
    columnKeys() {
      return [
        { value: "updateDate", text: "登入日期", sortable: true, required: false },
        { value: "transactionDate", text: "匯款日期", sortable: true, required: false },

        { value: "title", text: "銀行名稱", sortable: true, required: false },
        { value: "subTitle", text: "分行", sortable: true, required: false },
        { value: "name", text: "戶名", sortable: true, required: false },
        { value: "account", text: "帳號", sortable: true, required: false },

        { value: "type", text: "類型", sortable: true, required: false , options:[
            {key : 0 , text:'匯款'},
            {key : 1 , text:'存入'}
          ], isSelect: true},
        { value: "targetTitle", text: "交易對象銀行", sortable: true, required: false },
        { value: "targetSubTitle", text: "交易對象銀行分行", sortable: true, required: false },
        { value: "targetName", text: "交易對象戶名", sortable: true, required: false },
        { value: "targetAccount", text: "交易對象帳號", sortable: true, required: false },
        { value: "price", text: "金額", sortable: true, required: false },
        { value: "edit", text: "編輯", sortable: false, required: false , color:'primary', isEvent: true},
        { value: "delete", text: "刪除", sortable: false, required: false , isEvent: true}]
    },
    getTotalItems() {
      return this.totalItems;
    },
    caseTypeList(){
      return [
        { key: 0, text: "匯款" },
        { key: 1, text: "存入" },
      ]
    },
    searchKeys() {
      return [
        { key: "targetName", value: "交易對象" },
        { key: "targetAccount", value: "交易帳號" },
      ];
    },
  },
  methods: {
    ...mapActions([
      "recordInfo",
      "recordList",
      "createRecord",
      "updateBank",
      "bankList",
      "createBank", 
      "deleteRecord",
      "updateRecord"
    ]),
    setDefualtDate() {
      let todayDate = new Date();
      todayDate.setMonth(todayDate.getMonth() - 1);
      let currentDate = todayDate.toISOString().substr(0, 10);
      const [thisYear, thisMonth, thisDay] = currentDate.split("-");
      this.search.startDate = `${thisYear}-${thisMonth}-01`;

      let futureDate = new Date();
      // 将当前月份加1，下移到下个月
      futureDate.setMonth(futureDate.getMonth() + 1);
      // 再获取天数即取上个月的最后一天的天数
      futureDate.setDate(0);
      let days = futureDate.getDate();

      let endDate = futureDate.toISOString().substr(0, 10);
      const [futureYear, futureMonth, futureDay] = endDate.split("-");

      this.search.endDate = `${futureYear}-${futureMonth}-${days}`;
    },
    changePage(page) { // 改變頁數 or 每頁筆數
      this.pageIndex = page.page;
      this.limit = page.rowsPerPage;
      this.loadData(this.pageIndex, this.limit);
    },
    changeTypeStatus() {
      this.loadData(this.pageIndex, this.limit);
    },
    async loadFavoriteBankList() {
      this.loading = true;
      this.loadBankInfo(1, (list) =>{
        this.favoriteBankItemList = list
        console.log(`favoriteBankItemList ${JSON.stringify( this.favoriteBankItemList)}`)
        this.loading = false;
      })
    },
    async loadBankList() {
      this.loading = true;
      this.loadBankInfo(0, (list) =>{
        this.bankItemList = list
        console.log(`bankItemList ${JSON.stringify( this.bankItemList)}`)
        this.loading = false;
      })
    },
    async loadBankInfo(type,resultEvent) {
      const data = {
        "favorite": type
      }
      const results = await this.bankList(data)    
      if (resultEvent) {
        resultEvent(results.data.data.list);
      }
    },
    async loadData(pageIndex, limit, isExport=false) {
      this.loading = true;
      let searchQuery = [{ "key" :"type" , "value":`${this.typeStatus}`}]
      if(this.search.searchKey && this.search.keyword) {
        searchQuery.push({ "key" :`${this.search.searchKey}` , "value":`${this.search.keyword}`})
      }

      const data = {
        startDate: `${this.search.startDate} 00:00:00`,
        endDate: `${this.search.endDate} 23:59:59`,
        pageIndex: pageIndex,
        limit: limit,
        searchQuery: searchQuery
      };

      const results = await this.recordList(data);

      this.items = results.data.data.list;
      this.items.forEach(element => {
        const bankInfoArray = this.bankItemList.filter((m) => m.bankId === element.bankId);
        const favoriteBankInfoArray = this.favoriteBankItemList.filter((m) => m.bankId === element.bankId);
        if(bankInfoArray.length || favoriteBankInfoArray.length) {
          const bankInfo = bankInfoArray.length ? bankInfoArray[0] : favoriteBankInfoArray[0]
          element.title = bankInfo.title
          element.subTitle = bankInfo.subTitle
          element.name = bankInfo.name
          element.account = bankInfo.account
        } 

        let bankInfoList = bankCodeList[element.targetTitle];
        const subCode = `${element.targetTitle}${element.targetSubTitle}`
        const array = bankInfoList.child.filter(child => child.code === subCode)

        element.targetTitle = bankInfoList.branch
        element.targetSubTitle = array.length ? array[0].branch : ''
      });
      console.log(`result === ${JSON.stringify(this.items)}`)
      this.totalItems = results.data.data.header.totalCount;
      this.loading = false;
    },
    createData(type) {
      this.isCreateInfo = true
      this.dataInfo(type)
    },
    dataInfo(type) {
      if(!this.editedItem.transactionDate) {
        this.editedItem.transactionDate = getCurrentDate();
      }
      if(!this.editedItem.agentId && this.getUserInfo.agentId) {
        this.editedItem.agentId = this.getUserInfo.agentId
      }
      this.cashInfoDialog.visible = true;
      this.cashInfoDialog.type = type;
      const self = this
      this.cashInfoDialog.confirm = (item) => {
        self.cashInfoDialog.visible = false;
        console.log(`cashInfoDialog ==== ${JSON.stringify(item)}`)
        self.createRecordInfo(item, self.isCreateInfo)
      },
      this.cashInfoDialog.cancel = () => {
        self.cashInfoDialog.visible = false;
      }
    },
    async createRecordInfo(item, isNew) {
      let results = {}
      if(isNew) {
        results = await this.createRecord(item)
      } else {
        results = await this.updateRecord(item)
      }
      const message = results.data.message
      this.showMessageDialog("成功", message,true,
          () => {
            this.messageDialog.visible = false
          },() => {})
      this.loadData(this.pageIndex, this.limit);
    },
    //交易明細
    async edit(item) {
      this.editedItem = item
      this.isCreateInfo = false;
      this.dataInfo(item.type)
    },
    cellEvent(props) { // cell 按鈕事件 (用Key判斷是點選哪一個
      console.log(`cellEvent ${JSON.stringify(props)}`)
      if (props.key === 'edit'){
        this.edit(props.item)
      }
      if (props.key === 'delete'){
        this.messageDialog.showCancelButton = true
        let message = `是否刪除交易對象 ${props.item.targetTitle}-${props.item.targetSubTitle}-${props.item.targetName}的紀錄？`
        this.showMessageDialog("提示",message,true, 
        () => {
          this.messageDialog.showCancelButton = false
          this.messageDialog.visible = false
          const info = {"recordId" : props.item.recordId}
          this.deleteEvent(info);
        }, () => {
          this.messageDialog.showCancelButton = false
          this.messageDialog.visible = false
        })
      }
    },
    exportData() {
      this.loadData(1, 10000, true);
    },
    showBankDialog(type) {
      this.bankDialog.visible = true;
      this.bankDialog.favorite = type
      const self = this;
      this.bankDialog.confirm = () => {
        self.bankDialog.visible = false;
        self.loadBankList();
        self.loadFavoriteBankList();
      };
      this.bankDialog.cancel = () => {
        self.bankDialog.visible = false;
      };
    },
    showMessageDialog(title, text, visible, confirmEvent, cancelEvent) {
      this.messageDialog.title = title;
      this.messageDialog.text = text;
      this.messageDialog.visible = visible;
      const self = this;
      this.messageDialog.confirm = () => {
        self.messageDialog.visible = false;
        if (confirmEvent) {
          confirmEvent();
        }
      };

      this.messageDialog.cancel = () => {
        self.messageDialog.visible = false;
        if (cancelEvent) {
          cancelEvent();
        }
      };
    },
    searchEvent() {
      this.loadData(this.pageIndex, this.limit);
    },
    reset(){
      this.search.searchKey = ''
      this.search.keyword = ''
      this.loadData(this.pageIndex, this.limit);
    },
    async deleteEvent(info){
      const results = await this.deleteRecord(info)
      this.showMessageDialog("提示",results.data.message,true,
        () => {
          this.messageDialog.visible = false
        }, () => {
          this.messageDialog.visible = false
        })

      this.loadData(this.pageIndex, this.limit);

    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/web/CashFlowView.vue